import { createModuleDescriptor } from '../../redux/module-descriptor';

import actions from './actions';
import selectors from './selectors';
import reducer from './reducer';
import saga from './sagas';

export * from './sagaUtils';
export * from './sagaIncommingCall';

export default createModuleDescriptor('communicationVideo', {
  saga,
  actions,
  reducer,
  selectors,
});
